import { Stack, useTheme } from "@mui/material";
import { usePermissionStore } from "controller";
import { PERMISSIONS } from "shared";
import { DashboardOverview } from "./DashboardOverview";
import { DashboardScopeFilter } from "./DashboardScopeFilter";
import { GreetingsSection } from "./GreetingsSection";

export const DashboardHeader = () => {
  const theme = useTheme();
  // Only resources allowed to see the whole desk may look at a teammate's
  // numbers — everyone else stays pinned to their own, so the filter isn't
  // rendered. This gate has to hold on its own: the V3 dashboard route's
  // middleware cannot see the request body, so a self-only resource that reached
  // the picker could ask for the whole MSP and be served it.
  const canViewTeamScope = usePermissionStore(
    (state) =>
      state.hasPermissions([PERMISSIONS.SD.SD_TICKET_ALL_RW]) ||
      state.isSuperAdmin() ||
      state.isAdmin(),
  );

  return (
    <Stack
      sx={{
        // The activity section below grows to fill the viewport — the header has
        // to keep its natural height instead of being squeezed for it.
        flexShrink: 0,
        backgroundColor: theme.palette.neutral.main,
        borderRadius: "8px",
      }}
    >
      <Stack>
        {/* Card background and the divider stay full-bleed; the content inside
            caps at 1600px and centres so it lines up with the activity section
            on 1920/2560/4K screens. */}
        <Stack sx={{ p: "12px 24px" }}>
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              width: "100%",
              maxWidth: "1600px",
              mx: "auto",
              minWidth: 0,
            }}
          >
            <GreetingsSection />
            {canViewTeamScope && <DashboardScopeFilter />}
          </Stack>
        </Stack>
        <Stack
          sx={{
            p: "12px 24px 16px",
            borderTop: `1px solid ${theme.palette.neutral["010"]}`,
          }}
        >
          <Stack
            sx={{
              width: "100%",
              maxWidth: "1600px",
              mx: "auto",
              minWidth: 0,
            }}
          >
            <DashboardOverview />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
